/* eslint-disable react/prop-types */
import { useState } from "react";
import apiClient from "../../../utils/apiClient";
import useToast from "../../../hooks/userToast";

export const EditableCell = ({
  value,
  onChange,
  record,
  onBlur,
  fetchData,
  setEditableRowIndex,
}) => {
  const [inputValue, setInputValue] = useState(value);
  const { toastSuccess, toastError } = useToast();
  const [isEditing, setIsEditing] = useState(true);
  console.log(record, "sd", onBlur);

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      console.log(record?.radiologist_details.id);

      // Make sure inputValue is not empty or invalid if needed (additional validation can be added)
      if (!inputValue) {
        throw new Error("Patient name cannot be empty");
      }

      // Pass the new value to parent component
      onChange(inputValue);

      // Send the API request to update the patient name
      await apiClient.patch(
        `studyInfo/referByDoctor/${record?.radiologist_details.id}`,
        {
          refer_by: inputValue,
        }
      );
      fetchData();
      setIsEditing(false);
      setEditableRowIndex(null);
      toastSuccess("Refered by Updated Successfully.");
      // Optionally you can reset editable state here if you need

      // Make it non-editable again

      // Optionally display a success message
      console.log("Patient name updated successfully!");
    } catch (error) {
      // Log the error and optionally display an error message to the user
      console.error("Error updating patient name:", error.message);

      // Optionally handle UI feedback, e.g., show an error message to the user
      toastError(
        "An error occurred while updating the patient name. Please try again."
      );
      setIsEditing(false);
    }
  };

  const handleBlur = () => {
    onChange(inputValue);
    // onSubmit(); // Reset editable state
    // setIsEditing(false);
  };

  return isEditing ? (
    <div className="cursor-pointer">
      <input
        type="text"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        autoFocus
      />
      <button onClick={handleSubmit}>Submit</button>
    </div>
  ) : (
    <span>{value}</span>
  );
};
